/**
 * [description]  created by lzy 20201229
 */
'use strict';
angular.module('featureUsageStatisticsBindEventModule', []).controller('featureUsageStatisticsBindEventCtrl', ['$scope', '$modalInstance', 'trsHttpService', 'data',
    function($scope, $modalInstance, trsHttpService, data) {
        initStatus();

        /**
         * [initStatus description]
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {
            $scope.data = {
                detail: data.detail
            };
        }

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [send description] 确定  filter 返回查询起始时间和结束时间
         * @return {[type]} [description]
         */
        $scope.send = function() {
            const params = angular.extend(angular.copy($scope.data.detail), {
                serviceid: 'mlf_buridecode',
                methodname: 'updatestat'
            });
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function() {
                $modalInstance.close();
            });
        };
    }
]);
